import { useRef } from "react";
import PosterCard from "./PosterCard";

// One Cineby-style rail: red-bar heading, horizontally scrollable cards, and
// hover arrows that page the rail by roughly a screenful.
export default function PosterRow({ title, items, getProgress, wide = false }) {
  const scroller = useRef(null);

  if (!items || items.length === 0) return null;

  const page = (dir) => {
    const el = scroller.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.9, behavior: "smooth" });
  };

  return (
    <section className="row" aria-label={title}>
      <h2 className="row-title">{title}</h2>
      <div className="row-wrap">
        <div className="row-scroller" ref={scroller}>
          {items.map((card) => (
            <PosterCard
              // Manual-library episode cards carry their own key: several
              // episodes of one show share a tmdbId, so the id alone collides.
              key={card.key || (card.contentType === "TV_SHOW" ? `tv-${card.tmdbId}` : `mv-${card.tmdbId}`)}
              card={card}
              wide={wide}
              progress={getProgress ? getProgress(card) : null}
            />
          ))}
        </div>
        {/* data-remote-skip: rail arrows are a mouse affordance. A TV remote
            advances the rail with Right, and a focusable arrow between two cards
            would steal the focus move. */}
        <button className="rail-arrow prev" data-remote-skip aria-label={`Scroll ${title} back`} onClick={() => page(-1)}>
          ‹
        </button>
        <button className="rail-arrow next" data-remote-skip aria-label={`Scroll ${title} forward`} onClick={() => page(1)}>
          ›
        </button>
      </div>
    </section>
  );
}
